///<reference path="../../../typings/tsd.d.ts" />
///<reference path="../../bindings/commons/API/Client/api.d.ts" />

module address {
    
    export class AddressService {
        $http: ng.IHttpService
        api: API.Client.AddressApi;

        /*@ngInject*/
        constructor($http: ng.IHttpService) {
            this.$http = $http;
            this.api = new API.Client.AddressApi(this.$http);
        };
        
        getState(countryCode:string): ng.IPromise<API.Client.StatesResponse> {
            return this.api.addressesCountriesCountryCodeStatesGet(countryCode).then(response => {
                return response.data.states;
            });
        };
        
        getCity(countryCode:string, stateCode:string): ng.IPromise<Array<API.Client.City>> {
            return this.api.addressesCountriesCountryCodeStatesStateCodeCitiesGet(countryCode,stateCode).then(response => {
                return response.data.cities;
            });
        };
        
        getCep(zipCode:number): ng.IPromise<API.Client.AddressesResponse> {
            return this.api.addressesGet(zipCode).then(response  => {
                return response.data && response.data.addresses[0];
            });
        }
    }
    
    angular.module('address', []).service('addressService', AddressService);
}

